<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row>
          <a-col :span="12">
            <a-form-item
              label="编号"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="['clientId',{rules: [{required: true, message: '请输入编号'}]}]"
                :disabled="showable || editable"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="密钥"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="['clientSecret',{rules: [{required: true, message: '请输入密钥'}]}]"
                :disabled="showable"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="12">
            <a-form-item
              label="域"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="['scope',{rules: [{required: true, message: '请输入域'}]}]"
                :disabled="showable"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="授权方式"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="['authorizedGrantTypes',{rules: [{required: true, message: '请输入授权方式'}]}]"
                :disabled="showable"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item
              label="回调地址"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="['webServerRedirectUri']"
                :disabled="showable"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="权限"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="['authorities']"
                :disabled="showable"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item
              label="自动放行"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-switch
                checkedChildren="是"
                :disabled="showable"
                unCheckedChildren="否"
                v-decorator="['autoapprove', {initialValue: true,valuePropName: 'checked',rules: [{required: true, message: '选择授权方式'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="令牌时效"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input-number
                style="width: 100%"
                v-decorator="['accessTokenValidity']"
                :disabled="showable"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item
              label="刷新时效"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input-number
                style="width: 100%"
                v-decorator="['refreshTokenValidity']"
                :disabled="showable"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="扩展信息"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="['additionalInformation']"
                :disabled="showable"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item
              label="资源ID"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="['resourceIds']"
                :disabled="showable"
              />
            </a-form-item>
          </a-col>
        </a-row>

      </a-form>
    </a-spin>
    <template slot="footer" >
      <div
        v-show="editable || addable"
      >
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>

</template>

<script>
import pick from 'lodash.pick'
import { getObj, addObj, putObj } from '@api/sys/client'
import { FormMixin } from '@/mixins/FormMixin'

export default {
  name: 'UserAddOrUpdate',
  mixins: [FormMixin],
  data () {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
    }
  },
  methods: {
    // 获取用户信息
    edit (id, type) {
      this.visible = true
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        getObj(id).then(res => {
          const record = res.data
          if (record.autoapprove === 'true') {
            record.autoapprove = true
          } else {
            record.autoapprove = false
          }
          this.$nextTick(() => {
            setFieldsValue(pick(record, ['clientId', 'clientSecret', 'resourceIds', 'scope', 'authorizedGrantTypes', 'webServerRedirectUri',
              'authorities', 'accessTokenValidity', 'refreshTokenValidity', 'additionalInformation', 'autoapprove']))
          })
        }).catch(err => {
          this.$message.error(err.msg)
        }).finally(_ => {
          this.confirmLoading = false
        })
      } else {
        resetFields()
      }
    },
    // 结束保存用户信息
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          try {
            if (this.type === 'add') {
              await addObj(values)
            } else if (this.type === 'edit') {
              await putObj(values)
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.visible = false
            }, 1500)
          } catch (err) {
            this.$message.error(err.msg)
            this.confirmLoading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
